import { NotificationsService } from '@/services/notifications.service';

export default {
  getNotifications(_, { params } = {}) {
    return NotificationsService.getList(params);
  },
};
